import { createFileRoute } from "@tanstack/react-router";
import { PortalCredentials } from "@/components/portal/portal-credentials";

export const Route = createFileRoute("/portal/credentials")({
  component: PortalCredentialsPage,
});

function PortalCredentialsPage() {
  return (
    <div className="space-y-8">
      <div className="space-y-1">
        <h1 className="font-heading font-semibold text-2xl tracking-tight">Credentials</h1>
        <p className="text-muted-foreground text-sm">
          Your licenses and certificates, when each expires, and renewals to send to HR.
        </p>
      </div>
      <PortalCredentials />
    </div>
  );
}
